<template>
  <div class="page-container module">
    <top-bar title="Home"></top-bar>
    <!-- Container -->
    <div class="container center h-full">
      <!-- TITLE -->
      <div class="bg-header">
        <div class="headline">Welcome to PandaVue</div>
        <div class="sub-headline">Home of WWF</div>
      </div>

      <!-- QUICK LINKS -->
      <div class="card-list">
        <div class="headline">Where do you want to go today?</div>
        <div class="group">
          <!-- LINKS -->
          <router-link class="item" :to="'/' + l.link" v-for="l in links" :key="l.link">
            <div class="image no-image">
              <div class="icon">
                <i :class="'icn icn-' + l.icon"></i>
              </div>
            </div>
            <div class="inner">
              <div class="major">{{ l.name }}</div>
              <div class="description">{{ l.description }}</div>
              <div class="cta">
                <div class="grad">View <i class="icn icn-chevron-double-right sm"></i></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';
import { MODULE, PERMISSION } from '@/helpers/security';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    TopBar,
  },
  data() {
    return {
      allLinks: [
        // {
        //   name: 'Reporting',
        //   description: 'Dynamic insights with Power BI',
        //   icon: 'presentation-chart-line',
        //   module: MODULE.PBI_REPORT_VIEWER,
        //   link: 'reports',
        // },
        {
          name: 'Overview',
          description: 'Donations on PandaVue at a glimps',
          icon: 'chart-pie',
          link: 'overview',
        },
        // {
        //   name: 'Donations',
        //   description: 'Take new donations',
        //   icon: 'table',
        //   module: MODULE.DOTP,
        //   link: 'donations-over-the-phone',
        // },
        // {
        //   name: 'Reports',
        //   description: 'Define and update your reports',
        //   icon: 'document-report',
        //   module: MODULE.PBI_REPORT,
        //   link: 'reports-management',
        // },
        {
          name: 'Users',
          description: 'Manage your users',
          icon: 'users',
          module: MODULE.USER,
          link: 'users',
        },
        // {
        //   name: 'Companies',
        //   description: 'Manage your companies',
        //   icon: 'office-building',
        //   module: MODULE.COMPANY,
        //   link: 'companies',
        // },
        // {
        //   name: 'Security Groups',
        //   description: 'Manage your security groups',
        //   icon: 'user-group',
        //   module: MODULE.SECURITY_GROUP,
        //   link: 'security-groups',
        // },
        // {
        //   name: 'Roles',
        //   description: 'Manage PandaVue Roles',
        //   icon: 'lock-open',
        //   module: MODULE.ROLES,
        //   link: 'roles',
        //   superAdminRequired: true,
        // },
        {
          name: 'Supporters',
          description: 'Manage supporters',
          icon: 'support',
          link: 'supporters',
        },
        {
          name: 'Exports Data',
          description: 'Exports donation',
          icon: 'document-download',
          link: 'exports-data',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: ['auth/currentUser'],
    }),
    isSuperAdmin() {
      return this.user && this.user.isSuperAdmin;
    },
    modules() {
      return MODULE;
    },
    permissions() {
      return PERMISSION;
    },
    links() {
      return this.allLinks.filter((e) => {
        if (e.superAdminRequired && !this.isSuperAdmin) return false;
        return e.module ? this.hasAccess(e.module) : true;
      });
    },
  },

  methods: {
    hasAccess(moduleCode) {
      if (Array.isArray(moduleCode)) {
        return (
          this.user &&
          (this.user.isSuperAdmin ||
            (this.user.permissions &&
              Object.keys(this.user.permissions).filter((e) => moduleCode.includes(e).length > 0)))
        );
      } else {
        return this.user && (this.user.isSuperAdmin || (this.user.permissions && this.user.permissions[moduleCode]));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @apply h-full;
}
</style>
